import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Mode } from '../entityFramework/enumerations/Mode';
import { useModuleFromRoute } from '../hooks/route/useModuleFromRoute';
import { useNavState } from '../navState/NavStateContext';
import { StringUtils } from '../utils/StringUtils';
import { TitleButton } from './TitleButton';

export const AddButton = ({ entity, augNavEntityObj }) => {

  const module = useModuleFromRoute();
  const routeEntity  = useEntityFromRoute();
  entity ??= routeEntity;
  const { entityObj } = useEntityMgr();
  const { navigateTo } = useNavState();
  
  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  if (!hasRole(`${module.toUpperCase()}_${entity}_SAVE`)) return;
  
  const add = () => {
    const route = module + '/' + StringUtils.toKebabConvention(entity);
    let navObj = { mode: Mode.DETAIL };

    // 1. If we don't supply an entityObj, navigate
    if (!entityObj) {
      navigateTo(route, navObj);
      return;
    }

    // 2. If we don't override the default FK behaviour, set parent FK's and navigate
    const lowerCamelEntity = StringUtils.toLowerCamel(routeEntity);
    navObj.entityObj = ['Id', 'Code', 'Name'].reduce((entityObjFks, key) => {
      entityObjFks[lowerCamelEntity + key] = entityObj[key.toLowerCase()];
      return entityObjFks;
    }, {});
  
    // 3. Otherwise, use the method passed
    if (augNavEntityObj) {
      augNavEntityObj(navObj.entityObj);
    }
    navigateTo(route, navObj);
  }

  
  return (
    <TitleButton
      dataTestId={'add-button'}
      icon={fas.faPlus}
      toolTip="Add"
      onClick={add}
    />
  )
}